import React, { forwardRef } from 'react';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}
const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  children,
  ...props
}, ref) => {
  return <div className="relative" data-id="element-111">
        <select className={`flex h-10 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none ${className}`} ref={ref} {...props} data-id="element-112">
          {children}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-500" data-id="element-113">
          <svg className="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-114">
            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" data-id="element-115" />
          </svg>
        </div>
      </div>;
});
Select.displayName = 'Select';
export { Select };